// homepage
var splashItems = document.querySelectorAll('.splash-i')
var splashEl = document.getElementById('splash')
var splashI = 0
var splashRun

function runSplash () {
  splashI < splashItems.length - 1 ? splashNext() : splashEnd()
}

function splashNext () {
 splashI++ 
 hideSplashItems()
 splashItems[splashI].classList.remove('dn')

}

function splashEnd () {
 clearInterval(splashRun)
 setTimeout(function(){splashEl.remove()}, 300)
}

function hideSplashItems () {
  splashItems.forEach(function (item) {
  	item.classList.add('dn') 
  })
}


if (splashEl) splashRun = setInterval(runSplash, 100)


// pure and vile page
var main = document.getElementById('pv-main')
var hori = document.getElementById('horizontal')


// this is for pure vile
if (hori) {
  window.addEventListener('scroll', function (e) {
    // the horizontal point in which the background turns to black
    var objective = main.offsetHeight - (main.offsetHeight / 1.8)

    if (window.scrollY >= objective) {
      if (!document.body.classList.contains('black')) document.body.classList.add('black')
    } else {
      if (document.body.classList.contains('black')) document.body.classList.remove('black')
    }
    hori.style.transform = 'translate3d(' + (-window.scrollY) + 'px, -50%, 0)'
  })
}


// blu
// blu page
var blu = document.getElementById('blu')
var bluImgs = document.querySelectorAll('.bluimg')
var bluCloseBtn = document.querySelector('.blu-close')
var bluText = document.querySelector('.blu-who')
var bluTxt = document.querySelectorAll('.blu-txt')

var bluI = 0
var direction = 'down'
var bluMax = bluImgs.length

// invert elements on hover
function handleBluInvert () {
  
  bluTxt.forEach(function (txt) {
    txt.addEventListener('mouseenter', invertBluTxts)
    txt.addEventListener('mouseleave', invertBluTxts)
  })
}

function invertBluTxts () {
  bluTxt.forEach(function (txt) {
     txt.classList.toggle('invert')
  }) 
}
  
if (bluTxt) handleBluInvert()
 
function bluNext () {
  // load images after wards
  loadImgFromData(document.querySelector('.blu' + (bluI + 2)))
  
  if (direction === 'down') {
    bluI++
    document.querySelector('.blu' + bluI).classList.add('db')
  } else if (direction === 'up') {
    document.querySelector('.blu' + bluI).classList.remove('db')
    bluI--
  }
  
  // control if close btn should be shown
  if (bluCloseBtn.classList.contains('dn')) bluCloseBtn.classList.remove('dn')

  
  // what text to show
  if (bluI < 14) bluText.innerHTML = 'WHO ARE YOU?'
  else if (bluI < bluMax && bluI <= 14) bluText.innerHTML = 'AN ANGEL TO SOME'
  else if (bluI === bluMax) bluText.innerHTML = 'A DEMON TO OTHERS'
  
  if (bluI === bluMax) direction = 'up'
  else if (bluI === 0) {
    direction = 'down'
    bluCloseBtn.classList.add('dn')
  }
}

function bluControl () {
  blu.addEventListener('click', bluNext)
  bluCloseBtn.addEventListener('click', function () {
  	resetBlu(false) 
  })
  // esc to close appp
  document.addEventListener('keyup', function (e) {
    if (e.keyCode === 27) resetBlu(true)
  })
  bluSetupBody()
}

function resetBlu (escClose) {
  bluI = escClose ? 0 : -1
  direction = 'down'
  bluCloseBtn.classList.remove('db')
  bluCloseBtn.classList.add('dn')
  
  bluImgs.forEach(function (img) {
    img.classList.add('dn')
    img.classList.remove('db')
  })
}
 
function bluSetupBody () {
  blu.classList.remove('dn')
  document.body.classList.add('no-t')
  document.body.classList.add('black')
}

function loadImgFromData (el) {
  var imgs
  
  if (el) imgs = el.querySelectorAll('img')
  
  if (el && imgs) {
    if (!el.classList.contains('img-loaded')) {
      imgs.forEach(function (img) {
      	var dataSrc = img.getAttribute('data-src')
        if (dataSrc) img.setAttribute('src', dataSrc)
      }) 
      
      el.classList.add('img-loaded')
    }
  }
}


document.addEventListener('DOMContentLoaded', function () {
  if (blu) bluControl()
})

/// nav
var storyParent = document.querySelector('.story-parent')
var storyLinks = document.querySelector('.story-links')

storyParent.addEventListener('mouseenter', showStory)
storyParent.addEventListener('mouseleave', hideStory)
storyParent.addEventListener('click', toggleStory)

function showStory () {
  storyLinks.style.display = 'block'
}
function hideStory () {
  storyLinks.style.display = 'none'
}

function toggleStory () {
 if (storyLinks.style.display === 'block') hideStory()
 else showStory()
}

// product sizes
var descSizes = document.getElementById('desc-sizes')
// the container afterwards
var postDescSizes = document.getElementById('post-desc-sizes')
var sg = document.getElementById('size-guide')
var openSg = document.getElementById('open-size')
var closeSg = document.querySelectorAll('.sg-close')

function createDescSizes () {
  var sizes = descSizes.innerHTML.match(/\|(.*?)\|/g)
  sizes.forEach(function (size) {
    var sSize = size.replace(/=|\|/gi, '').trim()
    var splitSizes = sSize.split(', ')
    
    var letter = sSize[0]
    console.log(letter)
    
    splitSizes.forEach(function (size, i) {
      if (i > 0) {
        document.querySelector('.tb-' + letter + i).innerHTML = size + '"'
      }
    })
  })
  
  
  openSg.addEventListener('click', function () {
    sg.classList.remove('dn')
  })
  
  closeSg.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sg.classList.add('dn')    
    })
  })
}

if (descSizes) createDescSizes()




// random site generator
function getBinary () {
  var rand = Math.random()
  return rand >= 0.5 ? 1 : 0
}

function setHomepage () {
  if (getBinary() === 0) document.body.classList.add('red')
}

// if (document.getElementById('indexxx')) setHomepage()


// load video

var vidParent = document.querySelector('.blu-video-container')
var vidChild = document.querySelector('video')

function loadVideo (el) {
  var attr = el.getAttribute('data-src')
  el.setAttribute('src', attr)
}

if (vidChild) loadVideo(vidChild)

// close splash page
var closeVideo = document.querySelectorAll('.close-video')
var bluVideo = document.getElementById('blu-video')

if (closeVideo) {
  closeVideo.forEach(function (el) {
    el.addEventListener('click', function () {
      bluVideo.remove()
    })
  })
}

// mute btn
var muteBtn = document.querySelector('.mute-btn')

if (muteBtn){
muteBtn.addEventListener('click', function () {
  var vid = document.querySelector('video')
  muteBtn.classList.toggle('state-muted')
  vid.muted = vid.muted ? false : true
})
}